module.exports = __webpack_public_path__ + "img/yh-icon-touxiang@2x.00264062.png";